module.exports = __webpack_public_path__ + "static/media/pan-card.f292a910.svg";